'use strict';

module.exports = function emoji_html(tokens, idx /*, options, env */) {
  return tokens[idx].content;
};



//////////////////
// WEBPACK FOOTER
// ./~/markdown-it-emoji/lib/render.js
// module id = 927
// module chunks = 1